import React from 'react';
const DefaultLineTable = ({ dados, titulo }) => (
  <div
    style={{
      maxWidth: '100%',
      overflowY: 'scroll',
      overflowX: 'scroll'
    }}
  >
    <table
      style={{
        width: '100%',
        boxShadow: '0px 1px 4px rgb(58, 58, 58, 0.25)',
        borderRadius: '8px'
      }}
    >
      <thead style={{ background: '#cccccc' }}>
        <tr width="5px">
          <th
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '.5rem',
              height: '56.02px'
            }}
          >
            {titulo}
          </th>
          {dados &&
            dados[0].data.map((a, i) => (
              <th
                style={{ border: 'none', padding: '.5rem', height: '56.02px' }}
              >
                {a[0]}
              </th>
            ))}
        </tr>
      </thead>

      <tbody>
        {dados &&
          dados.map((a, i) => (
            <tr
              key={a.a}
              style={{
                marginTop: '1rem',
                background: `${i % 2 ? '#d9d9d9' : '#fff'}`
              }}
            >
              <td
                style={{
                  marginLeft: '1rem',
                  height: '61px',
                  display: 'flex',
                  justifyContent: 'center',
                  border: 'none',
                  fontWeight: 600
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    background: `${i % 2 ? '#d9d9d9' : '#fff'}`,
                    display: 'flex',
                    justifyContent:
                      titulo && titulo == 'Escolas' ? 'start' : 'center',
                    alignItems: 'center'
                  }}
                >
                  {a.name}
                </div>
              </td>
              {a.data.map((data) => (
                <td
                  style={{
                    marginTop: '1rem',
                    background: `${i % 2 ? '#d9d9d9' : '#fff'}`,
                    border: 'none'
                  }}
                >
                  {data[1] ? (
                    data[1].toFixed(2)
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        background: `${i % 2 ? '#d9d9d9' : '#fff'}`,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      ---
                    </div>
                  )}
                </td>
              ))}
            </tr>
          ))}
      </tbody>
    </table>
  </div>
);

DefaultLineTable.defaultProps = {
  aplicacoes: []
};

export default DefaultLineTable;
